module.exports = __webpack_public_path__ + "img/ai辅助设计平台图.3ebeb5b9.png";